import Home from './components/Home/Home';

type AppProps = {
  rtl: boolean
}

function App(props: AppProps) {
  return (
    <>
     <Home {...props}/> 
    </>
  );
}

export default App;
